import api from "@/services/api";

export default {
  get_entry_poll(payload) {
    let auth_url = payload.authenticated ? "admin" : "user";
    return api.get(
      "entry_polls/" 
      + auth_url + "/"
      + payload.id + "/"
      , payload).then(response => response.data);
  },
  update_entry_poll(payload) {
    return api.patch(
      "entry_polls/admin/"
      + payload.id + "/"
      , payload.form).then(response => response.data);
  },
  send_entry_poll(payload) {
    let auth_url = payload.authenticated ? "admin" : "user";
    return api.put(
      "entry_polls/" 
      + auth_url + "/"
      + payload.id + "/"
      , payload.form).then(response => response.data);
  },
  create_entry_poll(payload) {
    let auth_url = payload.authenticated ? "admin" : "user";
    return api.post(
      "entry_polls/" 
      + auth_url + "/"
      , { id: payload.id }
    ).then(response => response.data);
  },
  delete_entry_poll(payload) {
    let auth_url = payload.authenticated ? "admin" : "user";
    return api.delete(
      "entry_polls/" 
      + auth_url + "/"
      + payload.id + "/"
    ).then(response => response.data);
  }
};